<div class="page ">
  <mat-spinner *ngIf="showProgress==true" class="mat-spinner-color" style=" justify-content: center; 
  align-items: center; margin:0 auto; z-index: 1000;" [diameter]="70" mode="indeterminate" ></mat-spinner>
 <app-top-header-green  customTitle={{categoryName}} ></app-top-header-green>
        <div  class=" m-auto widthPage" >
                <div class="d-flex flex-wrap list" 
      infinite-scroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollUpDistance]="scrollUpDistance"
      [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown()"
      (scrolledUp)="onUp()">
                   <div  *ngFor="let i of restaurantsItem; let ind = index"   class="listLocation">
                   <app-resraurant-item
          (change)="ngOnInit()" 
          [mainRestaurantItem]="i" 
          [indexList]="ind"
          [restaurantCategory]="8"
          (click)="onClickCategory(i.RstaurantID)"
        ></app-resraurant-item> 
              <!-- <app-category-item  (change)="ngOnInit()" (click)="onClickCategory(i.RstaurantID)"  style="cursor: pointer;" [categoryItem]="i" [category]="category" [indexList]="ind" [restaurantCategory]="8"></app-category-item> -->
                </div>
            </div>
            </div>